import React from 'react'
import { RevalidateCard } from '../../organisms/RevalidateCard'
import { Controller } from 'react-hook-form'
import { isValidEmail } from '../../../util/validators'
import { EmailRevalidateInput } from '../../organisms/EmailRevalidateInput'
import PropTypes from 'prop-types'

export const EmailRevalidateTemplate = ({
  error,
  shouldDisableSendButton,
  onMailCheckSuggestionClick,
  alreadyHasEmail,
  inputControl,
  onBack,
  onSubmit,
  onClickFooterButton,
  clearErrors,
  isSubmitting,
}) => {
  return (
    <RevalidateCard
      title="Verificação de e-mail"
      description="Um código de confirmação será enviado para o seu endereço de e-mail."
      alertDescription="O mesmo endereço de e-mail não pode ser usado em mais de uma conta OLX."
      buttonDescription="Enviar código para esse e-mail"
      footerDescription="Não tem mais acesso a esse e-mail? "
      error={error}
      disableSendButton={shouldDisableSendButton}
      isLoading={isSubmitting}
      showFooter={alreadyHasEmail}
      onBack={onBack}
      onSend={onSubmit}
      onClickFooterButton={onClickFooterButton}
      caption={{
        description: 'Não tem mais acesso a esse e-mail?',
        buttonDescription: 'Clique aqui',
      }}
      callBackCaptionButton={onClickFooterButton}
    >
      <EmailRevalidateInput
        onMailCheckSuggestionClick={onMailCheckSuggestionClick}
        isSubmitting={isSubmitting || alreadyHasEmail}
        clearErrors={clearErrors}
        inputWrapper={renderComponent => {
          return (
            <Controller
              control={inputControl}
              name="email"
              rules={{
                validate: email => alreadyHasEmail || isValidEmail(email),
              }}
              render={renderComponent}
            />
          )
        }}
      />
    </RevalidateCard>
  )
}

EmailRevalidateTemplate.propTypes = {
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
  onMailCheckSuggestionClick: PropTypes.func,
  onClickFooterButton: PropTypes.func,
  shouldDisableSendButton: PropTypes.bool,
  alreadyHasEmail: PropTypes.bool,
  inputControl: PropTypes.object,
  error: PropTypes.object,
  clearErrors: PropTypes.func,
  isSubmitting: PropTypes.bool,
}
